var React = require('react');

function Doorsteps (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M13.832 17.712h-10.58l-1.263 1.273v1.223h13.09v-1.223z","key":0}),React.createElement("path",{"d":"M15.726 21.439h-14.368l-1.262 1.272v1.223h16.877v-1.223z","key":1}),React.createElement("path",{"d":"M11.715 9.169c-.508 0-.919-.403-.919-.901 0-.497.411-.899.919-.899.507 0 .919.402.919.899s-.412.901-.919.901zm-8.525 7.255h10.689v-16.309h-10.689v16.309z","key":2})]));
}

Doorsteps.defaultProps = {"width":"17","height":"24","viewBox":"0 0 17 24"};

module.exports = Doorsteps;

Doorsteps.default = Doorsteps;
